import React from 'react';
import { CtaButton } from './CtaButton';
import { reviewSteps } from '../data/content';
export function ReviewSystem() {
  return <section className="bg-brand-900 py-16 text-white sm:py-24" aria-labelledby="system-title" data-id="element-270" data-mp="36q2g545y1hw9">
      <div className="mx-auto grid max-w-5xl gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16" data-id="element-271" data-mp="3bn2oxmu6gyr2">
        <div data-id="element-272" data-mp="3gg5jnyaoye8u">
          <p className="text-sm font-bold uppercase tracking-wider text-brand-300" data-id="element-273" data-mp="3ggoqaiuw5g7k">
            The 15-minute CBCT review system
          </p>
          <h2 id="system-title" className="mt-3 font-serif text-[32px] font-extrabold leading-tight sm:text-5xl" data-id="element-274" data-mp="3pfsbpthj67p8">
            A 7-Step Map for Reviewing the Information That{' '}
            <em className="text-brand-300" data-id="element-275" data-mp="3udaojuyo572i">Matters</em> Before Implant Planning
          </h2>
          <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-brand-100" data-id="element-276" data-mp="36hncr3vl7xz">
            <p data-id="element-277" data-mp="202yo5hnc120k">The goal isn’t to memorize hundreds of anatomical facts.</p>
            <p className="text-lg font-semibold text-white" data-id="element-278" data-mp="25105ny540t9x">
              The goal is to have a repeatable sequence that tells you what to look at, what to document, and what
              questions to ask before moving forward.
            </p>
            <p data-id="element-279" data-mp="o9sagcajnkeh">That’s exactly what I created with the CBCT Decision Map™.</p>
          </div>

          <div className="mt-8 border-l-4 border-brand-400 pl-5" data-id="element-280" data-mp="o7fs3y0vj80w">
            <h3 className="font-serif text-2xl font-bold" data-id="element-281" data-mp="jcac1fu5knkq">More Than a CBCT Guide</h3>
            <p className="mt-2 text-[17px] leading-relaxed text-brand-100" data-id="element-282" data-mp="1gx4x0mgpfs7s">
              It’s a complete review system designed to sit beside you while you analyze a case. Inside, I have
              organized the process into 6 practical volumes, each designed around a specific part of CBCT
              interpretation and implant planning.
            </p>
          </div>
        </div>

        <ol className="relative space-y-3" aria-label="The 7-step CBCT review sequence" data-id="element-283" data-mp="3rrk7i53jeujj">
          <span className="absolute bottom-6 left-[23px] top-6 w-px bg-brand-600" aria-hidden="true" data-id="element-284" data-mp="3nonvix8i5wok" />
          {reviewSteps.map((step, i) => <li key={step.title} className="relative flex items-center gap-4 rounded-2xl bg-brand-800/70 p-3 pr-4" data-id="element-285" data-mp="3p401yre32ywl" data-mpi={i}>
              <span className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-white font-serif text-xl font-extrabold text-brand-800" data-id="element-286" data-mp="3u2tdwfdq2hun">
                {i + 1}
              </span>
              <div data-id="element-287" data-mp="36fv3nzg74656">
                <p className="text-[15px] font-extrabold uppercase tracking-wide" data-id="element-288" data-mp="36fbi88rc6zme">{step.title}</p>
                <p className="text-sm text-brand-200" data-id="element-289" data-mp="3b6jsf70hqp0m">{step.text}</p>
              </div>
            </li>)}
        </ol>
      </div>

      <div className="mx-auto mt-12 max-w-5xl px-4 sm:px-6" data-id="element-290" data-mp="2wj8hn7c4v91k">
        <CtaButton label="I want to follow the 7-step sequence" data-id="element-291" data-mp="31fp3tvzrvdc0" />
      </div>
    </section>;
}